import { DependencyInjectionContainer } from "./dependency-injection-container";
import { NodeManager } from "../node-manager/entities/node-manager";

const nodeManagerKey = "nodeManager";

export const getNodeManager = () => {
  return DependencyInjectionContainer.getInstance().resolve<NodeManager>(
    nodeManagerKey,
  );
};

export const registerNodeManager = () => {
  DependencyInjectionContainer.getInstance().register(
    nodeManagerKey,
    NodeManager,
  );
};
